/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-22 17:59:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-09-06 16:25:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/index.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
//import css from './css.module.less';
import NoPermission from '@/src/components/NoPermission';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Form } from 'src/components/Antd';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import {
  EnumMultiLanguageType,
  useQueryLanguageListContentEditor,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  getCheckoutSettings,
  postCheckoutSettings,
} from 'src/request/salesChannel/setting/checkout';
import { useComponentMemo } from 'src/tools/customHooks';
import { timeoutScroll } from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import _CommentBox from './CheckoutCommentBox';
import _ChinaFapiao from './ChinaFapiao';
import TopLeft from './Components/TopLeft';
import TopRight from './Components/TopRight';
import _CrossBoardSetting from './CrossBoardSetting';
import _DeliveryAddressSettings from './DeliveryAddressSettings';
import Provider, { CheckoutErrorContext } from './ErrorContext';
import _GuestCheckoutCustomerInformation from './GuestCheckoutCustomerInformation';
import _CheckoutOption from './GuestCheckoutOption';
import _Promotion from './PromotionBar';
import _RecipientInfo from './RecipientInfo';
import _TermsAndConditions from './TermsAndConditions';
import _GiftCard from './GiftCard';
import { convertDataFromServer } from './tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';

const salesChannelMultiLanguageQueryParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  //  salesChannelMultiLanguageUpdate: true,
};
const salesChannelMultiLanguageParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
};

const permissions = (uuid: string) => {
  const view_checkout_settings = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelCheckout,
        operation: EnumOperation.view_checkout_settings,
        uuid,
      }),
    ],
  });
  const edit_checkout_setting = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelCheckout,
        operation: EnumOperation.edit_checkout_setting,
        uuid,
      }),
    ],
  });

  return {
    view_checkout_settings,
    edit_checkout_setting,
  };
};

const Checkout = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPrimary } = props;
  const { uuid }: any = useParams();
  const { view_checkout_settings, edit_checkout_setting } = permissions(uuid);
  const {
    resetStatus,
    setTcEmptyError,
    setReInformationEmptyError,
    // setGuestCheckoutEmptyError,
  } = React.useContext(CheckoutErrorContext);
  const currentLanguage = useQueryLanguageListContentEditor();
  const [form] = Form.useForm();
  const [hasModified, setHasModified] = React.useState(false);
  //console.log(hasModified);
  const [loaded, setLoaded] = React.useState(false);

  const [guestCheckout, setGuestCheckout] = React.useState(false);
  const [customerInfo, setCustomerInfo] = React.useState([]);
  const [fields, setFields] = React.useState([]);

  const [recipientInfo, setRecipientInfo] = React.useState([]);

  const [deliveryAddressSetting, setDeliveryAddressSetting] = React.useState(
    [],
  );

  const [formats, setFormats] = React.useState([]);

  const [crossBorderSetting, setCrossBorderSetting] = React.useState([]);

  const [termsConditions, setTermsConditions] = React.useState([]);
  const [termsConditionsList, setTermsConditionsList] = React.useState([]);

  // const [commentBox, setCommentBox] = React.useState({});
  const [promotionBar, setPromotionBar] = React.useState({});
  const [giftCard, setGiftCard] = React.useState({});

  const [chinaInvoice, setChinaInvoice] = React.useState(false);
  const [isChina, setIsChina] = React.useState(false);

  const restData = React.useRef<any>({});
  const commentRef = React.useRef<any>(false);

  const getData = () => {
    setLoaded(false);
    getCheckoutSettings(uuid, salesChannelMultiLanguageQueryParams).then(
      (res: any) => {
        assData(res);
        // console.log('ini', res);
      },
    );
  };
  const assData = (res, basicDataOnly?) => {
    const {
      customerInfo,
      recipientInfo,
      crossBorderSetting,
      termConditions,
      addressLocalisationFormats,
      destinations,
      termsConditionsList,
      commentBox,
      promotionBar,
      guestCheckout,
      customerInfoFields,
      chinaInvoice,
      isChina,
      giftCard,
      ...rest
    } = convertDataFromServer(res, basicDataOnly);
    setGuestCheckout(guestCheckout);
    //
    setCustomerInfo(customerInfo || []);
    if (!basicDataOnly) setFields(customerInfoFields);
    //
    setRecipientInfo(recipientInfo || []);
    //
    setDeliveryAddressSetting(destinations);
    if (!basicDataOnly) setFormats(addressLocalisationFormats);
    //
    setCrossBorderSetting(crossBorderSetting);
    //
    setTermsConditions(termConditions);
    if (!basicDataOnly) setTermsConditionsList(termsConditionsList);
    //
    form.setFieldsValue({
      commentBox: commentBox || {},
    });
    //
    setPromotionBar(promotionBar);
    setGiftCard(giftCard);
    //
    setChinaInvoice(chinaInvoice);
    if (!basicDataOnly) setIsChina(isChina);
    //
    restData.current = rest;
    commentRef.current = get(commentBox, 'enabled');

    setLoaded(true);
  };

  React.useEffect(() => {
    if (view_checkout_settings) {
      resetStatus();
      getData();
    } else {
      setLoaded(true);
    }
  }, [currentLanguage]);

  const handleOnSubmit = (values) => {
    const { commentBox } = values;
    //需要校验的
    if (isPrimary) {
      // if (guestCheckout && customerInfo.length === 0) {
      //   setGuestCheckoutEmptyError(true);
      //   timeoutScroll('SalesChannelCheckoutCustomerInfoTable');
      //   return;
      // }
      if (recipientInfo.length === 0) {
        setReInformationEmptyError(true);
        timeoutScroll('SalesChannelCheckoutRecipientInfoTable');
        return;
      }
      if (termsConditions.length === 0) {
        setTcEmptyError(true);
        timeoutScroll('SalesChannelCheckoutTCTable');
        return;
      }
    }
    const _promotionBarEnabled = get(promotionBar, 'enabled');
    const _commentBoxEnabled = get(commentBox, 'enabled');

    const __commentBox = () => {
      if (isPrimary) {
        return _commentBoxEnabled ? commentBox : { enabled: false };
      } else {
        return { ...commentBox, enabled: commentRef.current };
      }
    };

    const res = {
      ...(restData.current || {}),
      guestCheckout,
      customerInfo: {
        fields: guestCheckout ? customerInfo : [],
      },
      recipientInfo: { fields: recipientInfo },
      deliveryAddressSetting: {
        destinations: deliveryAddressSetting,
      },
      crossBorderSetting: {
        destinations: crossBorderSetting,
      },
      termsConditionsSetting: {
        termsConditions,
      },
      commentBox: __commentBox(),
      promotionBar: _promotionBarEnabled ? promotionBar : { enabled: false },
      giftCard,
      chinaInvoice,
      salesChannelUuid: uuid,
    };
    postCheckoutSettings(res, salesChannelMultiLanguageParams).then((res) => {
      assData(res, true);
      setHasModified(false);
      msg.success(
        getI18n('salesChannelCheckout.index.checkoutsettingshasbeenupdated'),
      );
    });
  };

  const CheckoutOption = useComponentMemo(
    <_CheckoutOption
      data={guestCheckout}
      onChange={setGuestCheckout}
      setHasModified={setHasModified}
      disableEdit={!edit_checkout_setting}
    />,
    [guestCheckout],
  );

  const GuestCheckoutCustomerInformation = useComponentMemo(
    <_GuestCheckoutCustomerInformation
      data={customerInfo}
      onChange={setCustomerInfo}
      setHasModified={setHasModified}
      fields={fields}
      disableEdit={!edit_checkout_setting}
    />,
    [customerInfo, fields],
  );

  const RecipientInfo = useComponentMemo(
    <_RecipientInfo
      isRecipient={guestCheckout}
      data={recipientInfo}
      onChange={setRecipientInfo}
      setHasModified={setHasModified}
      title={getI18n('salesChannelCheckout.index.recipientInformation')}
      subtitle={getI18n('salesChannelCheckout.index.recipientInformationSub')}
      disableEdit={!edit_checkout_setting}
    />,
    [recipientInfo, guestCheckout],
  );

  const DeliveryAddressSettings = useComponentMemo(
    <_DeliveryAddressSettings
      setHasModified={setHasModified}
      onChange={setDeliveryAddressSetting}
      data={deliveryAddressSetting}
      formats={formats}
      disableEdit={!edit_checkout_setting}
    />,
    [formats, deliveryAddressSetting],
  );

  const CrossBoardSetting = useComponentMemo(
    <_CrossBoardSetting
      data={crossBorderSetting}
      onChange={setCrossBorderSetting}
      setHasModified={setHasModified}
      isPrimary={isPrimary}
      disableEdit={!edit_checkout_setting}
      salesChannelUuid={uuid}
    />,
    [crossBorderSetting, isPrimary, uuid],
  );

  const TermsAndConditions = useComponentMemo(
    <_TermsAndConditions
      data={termsConditions}
      tcs={termsConditionsList || []}
      onChange={setTermsConditions}
      setHasModified={setHasModified}
      disableEdit={!edit_checkout_setting}
    />,
    [termsConditions, termsConditionsList],
  );

  const CommentBox = useComponentMemo(
    <_CommentBox
      setHasModified={setHasModified}
      isPrimary={isPrimary}
      disableEdit={!edit_checkout_setting}
    />,
    [isPrimary],
  );

  const PromotionBar = useComponentMemo(
    <_Promotion
      setHasModified={setHasModified}
      data={promotionBar}
      onChange={setPromotionBar}
      isPrimary={isPrimary}
      disableEdit={!edit_checkout_setting}
    />,
    [promotionBar, isPrimary],
  );

  const ChinaFapiao = useComponentMemo(
    <_ChinaFapiao
      data={chinaInvoice}
      onChange={setChinaInvoice}
      setHasModified={setHasModified}
      disableEdit={!edit_checkout_setting}
    />,
    [chinaInvoice],
  );

  const GiftCard = useComponentMemo(
    <_GiftCard
      data={giftCard}
      onChange={setGiftCard}
      setHasModified={setHasModified}
      disableEdit={!edit_checkout_setting}
    />,
    [giftCard],
  );

  const _elements = () => {
    if (isPrimary) {
      if (guestCheckout) {
        const a = [
          { child: CheckoutOption },
          { child: GuestCheckoutCustomerInformation },
          { child: RecipientInfo },
          { child: DeliveryAddressSettings },
          { child: CrossBoardSetting },
          { child: TermsAndConditions },
          { child: CommentBox },
          { child: PromotionBar },
          {
            child: GiftCard,
          },
        ];
        if (isChina) {
          a.push({
            child: ChinaFapiao,
          });
        }
        return a;
      } else {
        const a = [
          { child: CheckoutOption },
          //  { child: GuestCheckoutCustomerInformation },
          { child: RecipientInfo },
          { child: DeliveryAddressSettings },
          { child: CrossBoardSetting },
          { child: TermsAndConditions },
          { child: CommentBox },
          { child: PromotionBar },
          {
            child: GiftCard,
          },
        ];
        if (isChina) {
          a.push({
            child: ChinaFapiao,
          });
        }
        return a;
      }
    } else {
      return [
        { child: CrossBoardSetting },
        { child: CommentBox },
        { child: PromotionBar },
        {
          child: GiftCard,
        },
      ];
    }
  };
  const elements = _elements();

  const onFinishFailed = ({ values, errorFields, outOfDate }) => {
    const pre = 'salesChannel-checkout_';
    if (errorFields[0]) {
      const first = (errorFields[0] || {}).name || [];
      const suf = first.join('_');
      const id = pre + suf;
      timeoutScroll(id);
    }
  };

  return view_checkout_settings ? (
    <React.Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.leave_content')}
      />
      {loaded ? (
        <Form
          onFinishFailed={onFinishFailed}
          form={form}
          name='salesChannel-checkout'
          onFinish={handleOnSubmit}>
          <Layout
            topLeft={<TopLeft />}
            topRight={
              <TopRight
                hasModified={hasModified}
                onSubmit={() => {
                  form.submit();
                }}
              />
            }
            elements={elements}
          />
        </Form>
      ) : null}
    </React.Fragment>
  ) : (
    <NoPermission />
  );
};
const Output = (props) => {
  return (
    <Provider>
      <Checkout {...props} />
    </Provider>
  );
};
export default SalesChannelModeAccessControlHOC(
  SalesChannelHOC(SelectHOC(Output), {
    type: EnumMultiLanguageType.SalesChannelSettingsCheckout,
  }),
);
